// ['Alle', 'Konto', 'Reiter-Profil', 'Pferde-Profil', 'Flip & Win']
export const AWARD_TYPE_ALL = 'Alle';
export const AWARD_TYPE_ACCOUNT = 'Konto';
export const AWARD_TYPE_RIDER_PROFILE = 'Reiter-Profil';
export const AWARD_TYPE_HORSE_PROFILE = 'Pferde-Profil';
export const AWARD_TYPE_FLIP_WIN = 'Flip & Win';

export const allAwardTypes = [
    AWARD_TYPE_ALL,
    AWARD_TYPE_FLIP_WIN,
    AWARD_TYPE_ACCOUNT,
    AWARD_TYPE_RIDER_PROFILE,
    AWARD_TYPE_HORSE_PROFILE,
];
